module.exports = __webpack_public_path__ + "img/stub_card_detail_invest.e326177.svg";